import { Media } from './media';

export interface Article {
  date: string;
  title: string;
  description: string;
  link: string;
  image: Media;
}
